<template>
  <div v-loading="loading" class="luckDraw">
    <div class="content-list" @click="detailData.name ? active = false : ''">
      <div class="type-tip" v-if="detailData && detailData.standardStatus && getActiveType() === 0">
        <img :src="detailData.standardStatus === 2 ? successPng : failPng" alt="">
        <div class="msg-box">
          <p class="text">{{text()}}</p>
          <p class="code" v-if="detailData && detailData.expressNumber">
            <span>快递单号：{{detailData.expressNumber}}</span>
            <span class="copy" @click="copy">复制</span>
          </p>
        </div>
      </div>
      <el-row>
        <el-col class="left" :span="3">活动名称：</el-col>
        <el-col class="right g-flex-start" :span="20">
          <span v-if="!active">{{ detailData && detailData.name }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">创建时间：</el-col>
        <el-col class="right" :span="20">{{ detailData && detailData.createTime }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动油站：</el-col>
        <el-col class="right" :span="20">{{ detailData && detailData.gasName }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动时间：</el-col>
        <el-col class="right" :span="20">{{ (detailData && detailData.beginTime || '--')+' 至 '+ (detailData && detailData.endTime || '-')}}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">收货人：</el-col>
        <el-col class="right" :span="20">{{ detailData && detailData.receiver }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">联系电话：</el-col>
        <el-col class="right" :span="20">{{ detailData && detailData.receiverPhone }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">收货地址：</el-col>
        <el-col class="right" :span="20">{{ detailData && detailData.address }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动说明：</el-col>
        <el-col class="right" :span="20">活动时间内，<span style="font-weight:700">拉新用户数达标后</span>，即可免费领取大奖</el-col>
      </el-row>
      <el-row class="margin">
        <el-col class="left" :span="3" style="min-height:120px"></el-col>
        <el-col class="right" :span="20">
          <div class="conditions-box">
            <p class="conditions-title">满足以下条件即为新用户：</p>
            <p v-for="(item, i) in detailData.conditions" :key="i" class="conditions-msg">{{item}}</p>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">达标奖励：</el-col>
        <el-col class="right" :span="20">活动结束后达成以下拉新条件，<span style="font-weight:700">达标范围内</span>， 可选择任意一项奖品，给您邮寄到手。</el-col>
      </el-row>
      <el-row class="margin">
        <el-col class="left" :span="3" style="min-height:250px"></el-col>
        <el-col class="right" :span="20">
          <TreasureList :rewardList="detailData.drawRewards" />
        </el-col>
      </el-row>
    </div>
    <div class="btn-groups" v-if="showButton">
      <el-button v-if="!detailData.expressNumber" class="btn1" @click="receivingInfo">修改收货信息</el-button>
      <el-button class="btn2" type="primary" @click="downCode">下载拉新二维码</el-button>
      <el-button v-if="getActiveType() !== 1" class="btn2" type="primary" @click="goDetail">效果分析</el-button>
    </div>
    <ReceivingInfo ref="receivingInfo"/>
  </div>
</template>
<script>
import { drawDetail, getQRcode } from '@/api/marketShop'
import TreasureList from '../../../marketPromotion/components/treasureList.vue'
import ReceivingInfo from '../../../marketPromotion/activeData/components/receivingInfo.vue'

export default {
  name: 'limitShopDetail',
  props: ['detailType', 'id', 'show', 'showButton', 'gasId', 'gasStatus'],
  inject: ['resetData', 'getListData'],
  components: { TreasureList, ReceivingInfo },
  data () {
    return {
      active: false,
      detailData: {
        conditions: []
      },
      regulationVos: [],
      loading: false,
      successPng: require('../../../../assets/image/success.png'),
      failPng: require('../../../../assets/image/fail.png')
    }
  },
  methods: {
    // 活动状态
    getActiveType () {
      /**
       * 已结束 0
       * 未开始 1
       * 进行中 2
       * **/
      const { detailData } = this
      if (!detailData) return 0
      let now = new Date().getTime()
      let start = new Date(detailData.beginTime).getTime()
      let end = new Date(detailData.endTime).getTime()
      if (now < start) return 1
      if (now < end) return 2
      return 0
    },
    text () {
      if (!this.detailData.standardStatus) return
      if (this.detailData.standardStatus === 0 || this.detailData.standardStatus === 1) {
        return '很遗憾，未达成拉新目标，再接再厉！'
      } else if (this.detailData && this.detailData.expressNumber) {
        return '达标商品已发货，请查收您的奖品！'
      } else {
        return '已达成拉新目标，请联系客户经理领取奖品！'
      }
    },
    // 复制
    copy () {
      var text = this.detailData.expressNumber || '123888'
      var input = document.createElement('input')
      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      document.execCommand('copy')
      document.getElementById('copyInput').remove()
      this.$message.success('复制成功')
    },
    goDetail () {
      this.$emit('close')
      const { detailType, id, gasId, gasStatus } = this
      this.$router.push({path: '/promotion/dataDetail', query: { activeId: id, activeType: detailType, gasId, gasStatus }})
    },
    receivingInfo () {
      this.$refs.receivingInfo.init(this.detailData.id)
    },
    // 下载二维码
    async downCode () {
      const { code, result } = await getQRcode()
      if (code !== 200) return
      let a = document.createElement('a')
      a.style.display = 'none'
      a.download = '油站名称'
      a.href = result
      document.body.appendChild(a)
      a.click()
    },
    // 初始化数据
    async initData () {
      this.loading = true
      try {
        const {code, result = {}} = await drawDetail({activeId: this.id})
        if (code !== 200) return
        this.detailData = result
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
  },
  watch: {
    show (val) {
      val && this.initData()
      this.active = false
    }
  },
  mounted () {
    this.initData()
  }
}
</script>
<style lang="less" scoped>
  @import url('./style.less');
  .luckDraw {
    .btn-groups {
      bottom: 0;
      height: 60px;
      background: #fff;
    }
    .type-tip {
      min-height: 74px;
      padding: 16px;
      background: #F9FAFC;
      border-radius: 4px;
      display: flex;
      align-items: center;
      img {
        width: 42px;
        height: 42px;
      }
      .msg-box {
        margin-left: 16px;
        .text {
          font-size: 16px;
          font-weight: 700;
          color: #222222;
          margin: 0;
          line-height: 22px;
        }
        .code {
          margin: 0;
          margin-top: 4px;
          font-size: 12px;
          color: #666666;
          line-height: 17px;
          .copy {
            color: #3377FF;
            margin-left: 16px;
            cursor: pointer;
          }
        }
      }
    }
    .content-list .margin {
      margin-top: 10px;
    }
    .conditions-box {
      background: #F9FAFC;
      border-radius: 4px;
      padding: 16px;
      min-height: 120px;
      .conditions-title {
        font-size: 14px;
        font-weight: 700;
        color: #222222;
        margin: 0 0 8px;
      }
      .conditions-msg {
        margin: 0;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }
    }
    .btn1{
      border: 1px solid #CCCCCC;
      color: #666;
      padding: 10px;
    }
    .btn2{
      border: 1px solid #4B7EFE;
      padding: 10px;
    }
  }
</style>